import * as React from 'react';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import Page from 'src/components/common/Page';
import Panel from 'src/components/common/Panel';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';

export interface ICostBreakdownSearchCriteria {
    rptId?: number;
    begDate?: string;
    endDate?: string;
    prospects?: string;
}

interface ICostBreakdownSearchProps {
    runQuery?: (criteria: ICostBreakdownSearchCriteria) => void;
    size?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14;
}

// Mirrors CheckRegisterSearch.tsx's query-by-example pattern - nothing is fetched until Search is
// clicked. Fields mirror the CONTROL header's own Report Id/Beg. Date/End Date/Prospects.
const CostBreakdownSearch = (props: ICostBreakdownSearchProps) => {
    const { register, errors, setValue, getValues } = useForm();
    const [isCollapsed, setIsCollapsed] = useState<boolean>(false);

    const toNumber = (numStr: string) => (!!numStr && !isNaN(Number(numStr)) ? Number(numStr) : undefined);

    const executeSearch = () => {
        const values = getValues();
        const criteria: ICostBreakdownSearchCriteria = {
            rptId: toNumber(values.rptIdSearch),
            begDate: values.begDateSearch || undefined,
            endDate: values.endDateSearch || undefined,
            prospects: values.prospectsSearch || undefined,
        };

        if (props?.runQuery) {
            props.runQuery(criteria);
        }
    };

    const clearSearchFilters = () => {
        setValue('rptIdSearch', '');
        setValue('begDateSearch', '');
        setValue('endDateSearch', '');
        setValue('prospectsSearch', '');

        if (props?.runQuery) {
            props.runQuery({});
        }
    };

    if (isCollapsed) {
        return (
            <div style={{ textAlign: 'center' }}>
                <Button
                    text="(+) Search Filters"
                    className="blue-hover-button"
                    style={{ height: '2rem', margin: '0', padding: '.2rem' }}
                    onClick={() => setIsCollapsed(false)}
                />
            </div>
        );
    }

    return (
        <Page style={{ justifyContent: 'center' }}>
            <Page.Section width={!!props?.size ? props.size : 12}>
                <Panel backgroundColor="#D3D3D3">
                    <Panel panelTitle="Cost Breakdown Search">
                        <form>
                            <div className="form-row" style={{ padding: '.5rem', margin: '0', flexWrap: 'nowrap', alignItems: 'flex-end' }}>
                                <div style={{ width: '12%' }}>
                                    <RHFInputBox
                                        label="Report Id"
                                        labelStyle={{ whiteSpace: 'nowrap' }}
                                        name="rptIdSearch"
                                        type="number"
                                        register={register}
                                        errors={errors}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </div>
                                <div style={{ width: '16%', paddingLeft: '4px' }}>
                                    <RHFInputBox
                                        label="Beg. Date"
                                        labelStyle={{ whiteSpace: 'nowrap' }}
                                        name="begDateSearch"
                                        type="date"
                                        register={register}
                                        errors={errors}
                                        setValue={setValue}
                                        clearable={true}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </div>
                                <div style={{ width: '16%', paddingLeft: '4px' }}>
                                    <RHFInputBox
                                        label="End Date"
                                        labelStyle={{ whiteSpace: 'nowrap' }}
                                        name="endDateSearch"
                                        type="date"
                                        register={register}
                                        errors={errors}
                                        setValue={setValue}
                                        clearable={true}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </div>
                                <div style={{ width: '24%', paddingLeft: '4px' }}>
                                    <RHFInputBox
                                        label="Client/Project"
                                        labelStyle={{ whiteSpace: 'nowrap' }}
                                        name="prospectsSearch"
                                        register={register}
                                        errors={errors}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </div>
                                <div style={{ display: 'flex', marginLeft: 'auto', flexShrink: 0, paddingLeft: '1rem' }}>
                                    <Button
                                        text="Search"
                                        className="blue-hover-button"
                                        style={{ whiteSpace: 'nowrap', width: '7rem', height: '3rem', verticalAlign: 'middle', marginLeft: '1rem', borderRadius: '5px' }}
                                        onClick={() => executeSearch()}
                                    />
                                    <Button
                                        text="(-) Minimize"
                                        className="blue-hover-button"
                                        style={{ whiteSpace: 'nowrap', marginLeft: '1rem', width: '9rem', height: '3rem', verticalAlign: 'middle', borderRadius: '5px' }}
                                        onClick={() => setIsCollapsed(true)}
                                    />
                                    <Button
                                        text="Clear"
                                        className="blue-hover-button"
                                        style={{ whiteSpace: 'nowrap', marginLeft: '1rem', width: '7rem', height: '3rem', verticalAlign: 'middle', borderRadius: '5px' }}
                                        onClick={() => clearSearchFilters()}
                                    />
                                </div>
                            </div>
                        </form>
                    </Panel>
                </Panel>
            </Page.Section>
        </Page>
    );
};

export default CostBreakdownSearch;



// WEBPACK FOOTER //
// ./src/components/project-billing/components/CostBreakdownSearch.tsx